import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var messageCenterListRoute = [{
  path: "messageCenterList",
  name: "messageCenterList",
  component: function component() {
    return import( /* webpackChunkName: "order-confirm" */"./message-center-list.vue");
  }
}];